module.exports = __webpack_public_path__ + "static/media/fallout4.4d8c201a.mp3";